import MobileDetect from "mobile-detect";

/* eslint-disable import/prefer-default-export */
export const localeURI = (uri) => {
  const url = new URL(window.location);
  const { protocol, hostname } = url;
  return url.port === "3000" ? `${protocol}//${hostname}:1337${uri}` : uri;
};

export const md = () => new MobileDetect(window.navigator.userAgent);

export const konami = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
];

export const socialNetworks = [
  'facebook',
  'instagram',
  'twitch',
  'twitter',
  'youtube',
];

export const addRedirectFromLogin = (router, route) => {
  router.push(`/sign-in/?redirectto=${route}`);
};

export const pullRedirectParamAndRedirect = (router) => {
  const { redirectto = "" } = router.location.query;
  if (redirectto) {
    router.push(redirectto);
  }
};

export const uploadToS3 = (file, preSignedUrl, eventListener) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', preSignedUrl);
  xhr.setRequestHeader('Content-Type', file.type);
  xhr.addEventListener('load', eventListener);
  xhr.send(file);
};

export const isAdminHasPermission1 = (user,functionName,regionName) => {
  let isHasPermission = false;
  if(user.permission&&user.permission.role){
    if(user.permission.role.name==='Super Admin'||!functionName){
      isHasPermission=true;
    }else if(user.permission.role.permissions&&user.permission.role.permissions.length>0){
      isHasPermission=user.permission.role.permissions.includes(functionName);
    }
  }
  let isHasRegion=false;
  if(user.permission&&user.permission.regions){
    if(!regionName){
      isHasRegion=true;
    }else if(user.permission.role.regions.length>0){
      isHasRegion=user.permission.role.permissions.find(r=>r.name === regionName)?true:false;
    }
  }
  return isHasPermission&&isHasRegion;
};

export const isFinance1 = (user) => {
  return isAdminHasPermission(user,'ApproveWithdrawals','');
};

/**
 * 根据分区格式化金额
 * @param user
 * @param amount
 * @param fix
 * @returns {*|string}
 */
export const getCurCurrency = (user,amount,fix=-1) => {
  return formatCurrency(user?.region?.currency,amount,fix);
};

/**
 * 根据货币单位格式化金额
 * @param unit
 * @param amount
 * @param fix
 * @returns {*|string}
 */
export const getCurCurrencyOfUnit = (unit,amount,fix=-1) => {
  return formatCurrency(unit,amount,fix);
};

/**
 * 获取当前货币单位的符号
 * @param unit
 * @returns {*}
 */
export const getCurCurrencyOfUnitSymbol = (unit) => {
  if(unit){
    try {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: unit,
        currencyDisplay: 'symbol'
      });
      if (formatter) {
        return formatter.formatToParts(1)?.find(part => part.type === 'currency')?.value;
        ;
      }
    }catch(err){
      console.error(err)
    }
    }
};

const formatCurrency = (unit,amount,fix=-1) => {
  if(!amount){
    amount=0;
  }
  if (typeof amount === 'number') {
  } else {
    amount = Number(amount);
  }
  if(fix<0){
    const numStr = amount.toString();
    const decimalPointIndex = numStr.indexOf('.');
    if (decimalPointIndex === -1) {
      fix = 0;
    }else {
      fix = numStr.length - decimalPointIndex - 1;
    }
  }
  if(fix>2){
    fix=2;
  }

  const p = Math.pow(10,fix);
  amount = Math.floor(amount * p) / p;
  amount = amount.toFixed(fix);
  const currency = unit;
  if(currency){
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: fix,
      maximumFractionDigits: 2,
      currencyDisplay: 'symbol'
    }).format(amount);
  }
  return amount;
};

/**
 * 格式化数字
 * @param number
 * @returns {string}
 */
export const formatNumber = (number) => {
  if(!number){
    number=0;
  }
  if (typeof number === 'number') {
  } else {
    number = Number(number);
  }
  return new Intl.NumberFormat('en-US', {
    useGrouping: true,
    groupingSeparator: ','
  }).format(number);
}

/**
 * 将时间字符串或者对象转化为本地的日期字符串
 * @param time
 * @returns {string}
 */
export const getLocalDay = (time) => {
  if(!time){
    return;
  }
  let lTime;
  if(time instanceof String){
    lTime = new Date(lTime);
  }else if(time instanceof Date){
    lTime = time;
  }else{
    return;
  }
  if(!lTime){
    return;
  }
  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };
  return lTime.toLocaleString('sv-SE',dateOptions);
};

/**
 * 将时间字符串或者对象转化为本地的时间字符串
 * @param time
 * @returns {string}
 */
export const getLocalTime = (time) => {
  if(!time){
    return;
  }
  let lTime;
  if(time instanceof String){
    lTime = new Date(lTime);
  }else if(time instanceof Date){
    lTime = time;
  }else{
    return;
  }
  if(!lTime){
    return;
  }
  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // 使用 24 小时制
  };
  return lTime.toLocaleString('sv-SE',dateOptions);
};
